module.exports = __webpack_public_path__ + "img/logo.b79551d1.png";